import AssociationChicletTitleContainer from './AssociationChicletTitleContainer';
import AssociationChicletProperties from './AssociationChicletProperties';
import AssociationChicletAssociationLabels from './AssociationChicletAssociationLabels';
import { HR } from 'foundations-components/transitional/components/HR';
import { Tile } from 'foundations-components/transitional/components/Tile';
import { TileSection } from 'foundations-components/transitional/components/Tile';
import { useRef } from 'react';
import useElementWidthObserver from '../../../hooks/useElementWidthObserver';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssociationChiclet({
  association
}) {
  const chicletRef = useRef(null);
  const chicletWidth = useElementWidthObserver(chicletRef);
  return /*#__PURE__*/_jsx("div", {
    ref: chicletRef,
    children: /*#__PURE__*/_jsx(Tile, {
      "data-selenium-test": "chicklet",
      "data-test-id": "chicklet",
      compact: true,
      paddingInline: "300",
      distance: "small",
      marginBlockStart: "0",
      children: /*#__PURE__*/_jsxs(TileSection, {
        paddingInline: "0",
        paddingBlock: "300",
        "data-test-id": `chiclet-${association.objectTypeId}-${association.objectId}`,
        children: [/*#__PURE__*/_jsx(AssociationChicletTitleContainer, {
          association: association,
          chicletWidth: chicletWidth
        }), /*#__PURE__*/_jsx(HR, {
          marginBlock: "200",
          backgroundColor: "border-core-subtle"
        }), /*#__PURE__*/_jsx(AssociationChicletProperties, {
          association: association
        }), /*#__PURE__*/_jsx(AssociationChicletAssociationLabels, {
          labels: association.labels,
          association: association
        })]
      })
    })
  });
}
export default AssociationChiclet;